module.exports = __webpack_public_path__ + "static/media/hwi4.b82b6297.webp";